const attachment_types = {
  AUDIO: ':audio',
  DOC: ':doc',
  FILE: ':file',
  IMG: ':img',
  VIDEO: ':video'
}

export default attachment_types
